//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'
import { mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js'

export default {
  setup() {
    const show1 = ref(false)
    const show2 = ref(true)
    const password = ref('Password')

    const rules = {
      required: value => !!value || 'Required.',
      min: v => v.length >= 8 || 'Min 8 characters',
    }

    return {
      show1,
      show2,
      password,
      rules,

      // icons
      icons: {
        mdiEyeOffOutline,
        mdiEyeOutline,
      },
    }
  },
}
